import { useEffect, useState } from 'react'
import { loadAwards, type AwardsIndex } from './awards'

/**
 * Lazy-loads the awards snapshot (/awards.json) and exposes the
 * parsed index. Subsequent components share the same promise through
 * the module-level cache in awards.ts, so opening the Awards tab
 * multiple times is essentially free after the first time.
 */
export function useAwardsIndex(): {
  index: AwardsIndex | null
  loading: boolean
  error: string | null
} {
  const [index, setIndex] = useState<AwardsIndex | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    loadAwards()
      .then((data) => {
        if (cancelled) return
        setIndex(data)
        setLoading(false)
      })
      .catch((err) => {
        if (cancelled) return
        setError(err instanceof Error ? err.message : String(err))
        setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [])

  return { index, loading, error }
}
